export enum ERROR_CODES {
  UNKNOWN = 0,
  // client codes start with 600
  UNKNOWN_CLIENT_ERROR = 600,
  CLIENT_REQUEST_PROCESSOR_FAILED = 601,
  CLIENT_REQUEST_PROCESSOR_FAILED_SDK_ROUND_2 = 602,
  CLIENT_REQUEST_PROCESSOR_FINAL_RESULT_PARTIAL = 603,
  // api errors start with 700
  UNKNOWN_API_ERROR = 700,
  UNKNOWN_QUERY_TYPE = 701,
  GRAPHQL_ERROR = 702,
  GRAPHQL_VALUE_RESOLUTION_ERROR = 703,
  GRAPHQL_PARSE_ERROR = 704,
  CONDITIONAL_EXPRESSION_PARTIALLY_EVALUATED = 705,
}

export interface V2Error {
  message: string;
  stack?: string;
  code?: ERROR_CODES;
}

export function isV2Error(arg: any): arg is V2Error {
  return typeof arg === 'object' && arg && 'message' in arg;
}
